module.exports = __webpack_public_path__ + "static/media/veronika.c60fcb0b.jpg";